import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';

// import { SanitizeHtml, buildThumbnailUrl, Image } from '@bd/bdcore-utilities';
// import VideoModal from '../../components//VideoModal';
import { typography, colors } from '../../styles';

const styles = css `
  padding: 40px 30px;
  margin: 0 0 0 0;
  @media(min-width: 992px) {
    padding: 70px 0;
  }
  @media(min-width: 1300px) {
    padding: 90px 0;
  }
  .PageSection_headerWrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 0 30px;
    .PageSection_header {
      color: ${colors.color1};
      font-size: 20px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 0.5px;
      text-align: center;
      position: relative;
      @media(min-width: 992px) {
        font-size: 28px;
      }
      @media(min-width: 1200px) {
        font-size: 32px;
      }
    }
  }
  .PageSection_processStep {
    flex-direction: column;
    padding: 0 0 20px;
    @media(min-width: 992px) {
      padding: 30px 0;
      flex-direction: row;
      .ContentBanner_content {
        padding-left: 30px;
      }
      &:nth-of-type(odd) {
        flex-direction: row-reverse;
        .ContentBanner_content {
          padding-right: 30px;
        }
      }
    }
  }
  .BackgroundImage {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 200px;
    height: 200px;
  }
  .ContentBanner_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 25px 0 0 0;
  }
  .ContentBanner_title {
    display: block;
    width: 100%;
    font-family: ${typography.Serif};
    font-weight: 400;
    font-style: italic;
    font-size: 28px;
    color: ${colors.color1};
    letter-spacing: .5px;
    -webkit-background-clip: text;
    text-align:left;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 30px;
    }
    @media(min-width: 1200px) {
      font-size: 35px;
    }
    &:after {
      content: '';
      display: block;
      width: 75px;
      height: 3px;
      background-color ${colors.color2Light};
      margin: 20px 0 15px 0;
    }
  }
  .ContentBanner_lead {
    p {
      font-weight: 300;
      font-size: 18px;
      letter-spacing: 0;
      line-height: 30px;
      padding: 0;
      @media(min-width: 992px) {
        font-size: 22px;
        line-height: 26px;
        padding: 0 30px 15px 0;
      }
      @media(min-width: 1100px) {
        font-size: 24px;
        line-height: 35px;
        padding: 0 30px 15px 0;
      }
    }
  }
`;

function ProcessPageSections({ page }) {
  const pageContent = get(page, 'process_section[0]');
  return (
    <div className={styles}>
      <div className="container">
        {
          get(pageContent, 'section_heading') &&
          <div className="PageSection_headerWrapper">
            <h2 className="PageSection_header">{get(pageContent, 'section_heading')}</h2>
          </div>
        }
        {
          get(pageContent, 'process', []).map(item => (
            <div className="row PageSection_processStep" key={item._id}>
              {
                get(item, 'image') &&
                <div
                  className="BackgroundImage col-12 col-lg-4"
                  style={{ backgroundImage: `url('${buildThumbnailUrl(item.image.contentUrl, { width: 1200, height: 1200 })}')` }}
                />
              }
              <div className="col-12 col-lg-8 order-lg-1">
                <div className="ContentBanner_content">
                  {
                    get(item, 'title') &&
                    <h2 className="ContentBanner_title">{get(item, 'title')}</h2>
                  }
                  {
                    get(item, 'body') &&
                    <div className="ContentBanner_lead" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'body'))} />
                  }
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

ProcessPageSections.propTypes = {
  page: PropTypes.object.isRequired,
};


export default ProcessPageSections;



// WEBPACK FOOTER //
// ./src/pages/BuildingProcess/ProcessPageSections.js